import React from 'react';
function NoPage() {
    return (
        <>No Fage found
        </>
    );
}
export default NoPage;